export const SELLER = "kitchen";
export const CUSTOMER = "customer";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

export const kitchenIMG = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/40cd0171e2342b3771c69244a1c38746";
